import Vue from 'vue'
import App from './App.vue'
import { router } from './router';
import store from './store';
import 'amfe-flexible'
import '@/assets/css/base.less'
import 'swiper/dist/css/swiper.css';
import '@/assets/css/index.less'
import { List, Toast, Popup, Swipe, SwipeItem } from 'vant';
Vue.use(List)
  .use(Toast)
  .use(Popup)
  .use(Swipe)
  .use(SwipeItem);
Vue.config.productionTip = false
import axios from 'axios'
Vue.prototype.$http = axios;
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
